import gql from 'graphql-tag';

export const GET_ACCOUNT_UTILITY_ACCOUNTS = gql`
  query getAccountUtilityAccount($accountId: Int!) {
    account(id: $accountId) {
      id
      utilityAccounts {
        id
        utility {
          id
          state {
            id
            name
            abbreviation
          }
        }
      }
    }
  }
`;

export const GET_ADVOCACY_CAMPAIGN_DASHBOARD = gql`
  query getAdvocacyCampaignDashboard($stateAbbreviation: String!) {
    state(abbreviation: $stateAbbreviation) {
      name
      activeAdvocacyCampaign {
        callToActionText
        editableBody
        id
        isDefault
        legislationDescription
        numberOfSubmissions
        shareText
        subjectLine
        successMessage
        successTitle
        uneditableBody
      }
      mostRecentCompletedAdvocacyCampaign {
        id
        message
        title
      }
    }
  }
`;

export const getAccountUtilityAccountsMock = {
  account: {
    id: 2,
    utilityAccounts: [
      {
        id: 1,
        utility: {
          id: 1,
          state: {
            id: 1,
            name: 'New Mexico',
            abbreviation: 'NM',
          },
        },
      },
    ],
  },
};

export const getAdvocacyCampaignDashboardMock = {
  state: {
    name: 'New Mexico',
    activeAdvocacyCampaign: {
      callToActionText: 'Do it!',
      editableBody: 'Things the customer might want to write to a rep.',
      id: 1,
      isDefault: true,
      legislationDescription:
        'This bill will bring community solar to your state.',
      numberOfSubmissions: 5,
      shareText: 'Join me in supporting community solar legislation',
      subjectLine: 'Vote for community solar',
      successMessage: 'Thank you for your support!',
      successTitle: 'You supported clean energy legislation',
      uneditableBody: 'Things the customer will definitely write to a rep.',
    },
    mostRecentCompletedAdvocacyCampaign: null,
  },
};

export const getNoAdvocacyCampaignDashboardMock = {
  state: {
    name: 'New Mexico',
    activeAdvocacyCampaign: null,
    mostRecentCompletedAdvocacyCampaign: null,
  },
};

export const getAdvocacyCampaignDashboardCompletedMock = {
  state: {
    name: 'New Mexico',
    activeAdvocacyCampaign: {
      callToActionText: 'Do it!',
      editableBody: 'Things the customer might want to write to a rep.',
      id: 1,
      isDefault: true,
      legislationDescription:
        'This bill will bring community solar to your state.',
      numberOfSubmissions: 4,
      shareText: 'Join me in supporting community solar legislation',
      subjectLine: 'Vote for community solar',
      successMessage: 'Thank you for your support!',
      successTitle: 'You supported clean energy legislation',
      uneditableBody: 'Things the customer will definitely write to a rep.',
    },
    mostRecentCompletedAdvocacyCampaign: {
      id: 1,
      message: 'Community Solar Passed!',
      title: 'We won!',
    },
  },
};
